<template>
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="470px" height="452px" viewBox="0 0 4700 4520" preserveAspectRatio="xMidYMid meet">
        <g id="layer1" :fill="color || '#fff'" stroke="none">
            <path d="M275 4268 c-3 -7 -4 -897 -3 -1978 l3 -1965 2080 0 2080 0 0 1975 0 1975 -2078 3 c-1657 2 -2079 0 -2082 -10z"/>
        </g>
    </svg>

</template>

<script>
export default {
    name: "Square",
    props: ["color"],
};
</script>





// WEBPACK FOOTER //
// src/components/V2/svg/components/Square.vue